import React, { Component } from 'react';
import { Tabs } from 'antd';
import { connect } from 'dva';
import Container from '@/components/Container';
import RoleList from './List';
import KeyPost from './KeyPost';
import ClassMaster from './components/Modal';
import styles from './index.less';

const { TabPane } = Tabs;

@connect()
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'keyPost',
    };
  }

  handleChange = key => {
    const { type } = this.state;

    if (key !== type) {
      this.setState({
        type: key,
      });
    }
  };

  render() {
    const { type } = this.state;
    return (
      <Container breStates={!0} version={2}>
        <div className={styles['contacts-role']}>
          <Tabs onChange={this.handleChange} type={type}>
            <TabPane tab="关键岗位设置" key="keyPost" />
            <TabPane tab="部门岗位设置" key="deptPost" />
            <TabPane tab="老师批量设置" key="classMaster" />
          </Tabs>
          <div className="content-body">
            {type === 'keyPost' && <KeyPost />}
            {type === 'deptPost' && <RoleList />}
            {type === 'classMaster' && <ClassMaster />}
          </div>
        </div>
      </Container>
    );
  }
}

export default index;
